<template>
    <div>
        <p>See more : <a href="https://github.com/DANLCARTON">github.com/DANLCARTON</a></p>
    </div>
</template>

<script>
export default {
    name: 'footerFoot',
}
</script>

<style scoped>
div {
    margin-top: 20px;
    background: #46b6da;
    color: white;
    z-index: 1000;
    box-shadow: 0 0 10px #00000050;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: ease-in-out .2s;
}
a {
    color: #efefef;
}
</style>